/**
 * useChatScroll Composable
 *
 * Auto-scrolls a container to the bottom when new messages arrive,
 * unless the user has scrolled up to read history.
 */
import { ref, watch, nextTick } from 'vue';
const SCROLL_THRESHOLD = 60;
export function useChatScroll(messages) {
    const scrollContainer = ref(null);
    const isUserScrolledUp = ref(false);
    function scrollToBottom() {
        const el = scrollContainer.value;
        if (!el)
            return;
        el.scrollTop = el.scrollHeight;
        isUserScrolledUp.value = false;
    }
    function handleScroll() {
        const el = scrollContainer.value;
        if (!el)
            return;
        const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
        isUserScrolledUp.value = distanceFromBottom > SCROLL_THRESHOLD;
    }
    watch(() => {
        const msgs = messages.value;
        const last = msgs[msgs.length - 1];
        return { count: msgs.length, contentLength: last?.content?.length ?? 0 };
    }, () => {
        if (!isUserScrolledUp.value) {
            nextTick(scrollToBottom);
        }
    });
    return {
        scrollContainer,
        scrollToBottom,
        handleScroll,
    };
}
export default useChatScroll;
